const dataLayerAttribute = {
    AB_TEST_STIE: "pe_test_site",
    PAGE_TYPE: "pe_page_type",
    RESTAURANT_ID: "pe_restaurant_id",
    BOOKING_REFERENCE: "pe_booking_reference",
    TIMESTAMP: "pe_timestamp",
    BOOKING_DETAILS: "pe_booking_details",
    MENU_TYPE: "pe_menu_type",
    DINING_DATE_REQUESTED: "pe_dining_date_requested",
    DINING_TIME_REQUESTED: "pe_dining_time_requested",
    DINING_GUESTS: 'pe_dining_guests',
    TABLE_AVAILABLE: "pe_table_available",
    CAMPAIGN_ID: "pe_campaign_id",
    CAMPAIGN_NAME: "pe_campaign_Name",
    OFFER_CODE: "pe_offer_code",
    STATS_GROUP: "pe_stats_group",
    EVENT: "event"
};

const validateDataLayerItem = (dataLayerKey/*: string*/, dataLayerValue/*: string*/) => {

    if (dataLayerKey) {

        var values = Object.values(dataLayerAttribute);

        for (var i = 0; values.length > i; i++) {
            var value = values[i];

            if (value === dataLayerKey) {
                return true;
            }
        }
    }

    return false;
};

const addToDataLayerSingle = (dataLayerKey/*: string*/, dataLayerValue/*: string*/) => {

    var collection = {};

    var validItem = validateDataLayerItem(dataLayerKey, dataLayerValue);

    if (validItem) {
        collection[dataLayerKey] = dataLayerValue;
    }

    flush(collection);
};

const addToDataLayerList = (dataLayerAttributes) => {
    var collection = {};

    if (dataLayerAttributes && dataLayerAttributes.length > 0) {

        //
        //  get the cookie
        let statsGroup = getCookie("FEX_SITE_STATS_GROUPPROD") || getCookie("FEX_SITE_STATS_GROUPUAT");
        if (!statsGroup)
            statsGroup = "FEX_INCLUDE";

        dataLayerAttributes
            .push(
                { [dataLayerAttribute.STATS_GROUP]: statsGroup });


        dataLayerAttributes.forEach(element => {
            if (element) {
                var objKeys = Object.keys(element);
                var objValues = Object.values(element);

                if (objKeys && objValues && objKeys.length && objValues.length) {
                    var key = objKeys[0];
                    var value = objValues[0];
                    var validItem = validateDataLayerItem(key, value)
                    if (validItem) {
                        collection[key] = value;
                    }
                }
            }
        });

        flush(collection);
    }
};

const flush = (collection) => {
    if (collection) {
        var ref = window.dataLayer;

        if (ref) {
            window.dataLayer.push(collection);
        }
    }
};

const getCookie = (cname) => {
    var name = cname + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(';');
    for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
        }
    }
    return null;
};

export default {
    dataLayerAttribute,
    validateDataLayerItem,
    addToDataLayerList,
    addToDataLayerSingle,
    flush,
    getCookie
}
